import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.063 4.643 8.375 1.937a.75.75 0 0 0-.75 0L2.937 4.643c-.017.01-.023.028-.039.039a.738.738 0 0 0-.189.189.656.656 0 0 0-.054.073c-.006.011-.017.018-.023.03a.746.746 0 0 0-.067.307v5.425a.751.751 0 0 0 .375.65l4.688 2.707a.753.753 0 0 0 .75 0l4.688-2.707a.751.751 0 0 0 .375-.65V5.293a.751.751 0 0 0-.378-.65ZM8 3.453l3.18 1.835-2.986 1.467-3.263-1.531Zm-3.938 3.02 3.188 1.5v4.145l-3.188-1.845Zm4.688 5.641V8.153l3.188-1.566v3.686Z';
const draw24px = 'M20.5,6.662l-8.12-4.688a.755.755,0,0,0-.75,0L3.505,6.662c-.016.01-.023.028-.038.039a.723.723,0,0,0-.189.189.551.551,0,0,0-.054.073.355.355,0,0,0-.023.031.739.739,0,0,0-.068.306l0,.012v9.376a.749.749,0,0,0,.375.649l8.12,4.688a.747.747,0,0,0,.75,0l8.12-4.688a.749.749,0,0,0,.375-.649V7.312A.751.751,0,0,0,20.5,6.662ZM11.25,20.077,4.63,16.255V8.492l6.62,3.1Zm1.089-9.622-.02-.014L5.5,7.243,12,3.49l6.673,3.853Zm7.031,5.8-6.62,3.822V11.924l6.62-3.252Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ViewDrawing3dIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'viewDrawing3d'));
ViewDrawing3dIcon.displayName = 'ViewDrawing3dIcon';
ViewDrawing3dIcon.propTypes = Icon.propTypes;
ViewDrawing3dIcon.renderIcon = props => /*#__PURE__*/React.createElement(ViewDrawing3dIcon, props);
export default ViewDrawing3dIcon;
//# sourceMappingURL=ViewDrawing3dIcon.js.map